import { IFeature, INameCode } from './models/pro-sites';

export const matchesNameCode = (value: string) => {
    return (element: INameCode) => {
        return element.name === value || element.code === value;
    };
};
